export default __webpack_public_path__ + "static/Perfect3-f895d9aeee4f5e673d85fff15ce16851.jpg";